/**
 * Our nation has capitulated but the war goes on. In a free-for-all the slip offers to observe
 * it "from the heights" (the host streams the whole truth, or any staff's view); in a team game
 * it explains why not — the staff map stays open and shows what the living allies see, nothing
 * more (engine `mayObserve`, docs/Networking.md → Observers).
 */
import { isFreeForAll, SPECTATOR } from '@friction/engine';
import { useState } from 'react';
import { bus } from '../../game/bus';
import { gameStore, useGame } from '../../game/store';
import { useT } from '../../i18n';
import { lobbyStore } from '../../net/lobby';
import { Button } from '../common/controls';
import { Paper, Stamp } from '../common/Panel';
import o from './overlays.module.css';

export function FallenNotice() {
  const t = useT();
  const fallen = useGame((g) => g.view !== null && !g.view.me.alive && g.view.winners === null);
  const ffa = useGame((g) => (g.view ? isFreeForAll(g.view.factions) : false));
  const [dismissed, setDismissed] = useState(false);
  if (!fallen || dismissed) return null;
  return (
    <div className={o.fallenWrap} role="alertdialog" aria-labelledby="fallen-title">
      <Paper className={o.fallen}>
        <Stamp className={o.fallenStamp} rotate={-7} animate delay={200}>
          {t('obs.fallen.stamp')}
        </Stamp>
        <div id="fallen-title" className={o.fallenTitle}>
          {t('obs.fallen.title')}
        </div>
        <p className={o.fallenText}>{ffa ? t('obs.fallen.ffa') : t('obs.fallen.team')}</p>
        <div className={o.fallenBtns}>
          {ffa && (
            <Button
              variant="primary"
              icon="eye"
              onClick={() => {
                bus.emit('sound', { name: 'paper' });
                gameStore.getState().observe(SPECTATOR);
              }}
            >
              {t('obs.observe')}
            </Button>
          )}
          <Button variant="ink" onClick={() => setDismissed(true)}>
            {t('obs.stay')}
          </Button>
          <Button variant="ink" icon="exit" onClick={() => lobbyStore.getState().quitGame()}>
            {t('obs.leave')}
          </Button>
        </div>
      </Paper>
    </div>
  );
}
